export const API = {
    BUFFER_TIME: 2,

    // Production
    // BASE_URL: 'https://api.xpansecafe.com/',
    // SOCKET_URL: 'https://api.xpansecafe.com/',

    // Development
    BASE_URL: 'https://xpanse.dev.bexcart.com/',
    SOCKET_URL: 'https://xpanse.dev.bexcart.com/',

    Branch_key: "key_test_jthIIltdWnnxR0S4u9CYqhdczFfO5NSG",
};

// export const RAZOR_PAY = {
//     RAZOR_PAY_KEY: 'rzp_live_F5u8OhE3jITTVm',
// } 

export const RAZOR_PAY = {
    RAZOR_PAY_KEY: 'rzp_test_ZxQ2jKSuJLuNC5',   
}
